import Link from "next/link";
import { useTranslations } from "next-intl";
import { ICategoryInput } from "@types";
import { useRouter } from "next/router";
import { toArabicNumber } from "@utils/digits";
import { segmentEvent } from "@utils/segment";
import { useAppContext } from "@context/app";
import ImagePrepare from "@elements/imagePrepare";

interface CategoryListProps {
  data: ICategoryInput[];
}

const CategoryList: React.FC<CategoryListProps> = ({ data }) => {
  const t = useTranslations();
  const { locale } = useRouter();
  const { user, country } = useAppContext()

  return (
    <div className="w-full max-w-[1248px] m-auto  px-2 mb-10">
      <div className="w-full mb-10">
        <p className="text-[28px] font-extrabold text-[#333333] capitalize">{`${t("client_general_categories")} (${locale?.includes("ar") ? toArabicNumber(data.length) : data.length
          })`}</p>
      </div>
      <div className="w-full overflow-auto flex flex-wrap items-center justify-center  p-0 mt-5">
        {data.map((category) => (
          <div key={`category-${category.id}`} className="sm:w-48 xs:w-1/2 w-1/2">
            <Link
              href={`/product?category_id=${category.id}`}
              passHref
              prefetch={false}
              onClick={() => {
                segmentEvent("Category Viewed", {
                  user_id: user.data?.id || -1,
                  country_id: country?.id,
                  country_slug: country?.slug,
                  language: locale?.includes("en") ? "English" : "Arabic",
                  category_id: category.id,
                  category_slug: category.slug,
                  from_page: "category_list",
                  from_entity: "",
                  from_entity_slug: "",
                  from_page_section: "",
                  from_page_section_entity: "",
                  from_page_section_slug: "",
                });
              }}
              legacyBehavior>

              <div className="w-full flex justify-center items-end h-40 px-[6px] mb-5">
                <div
                  className={`w-full h-[100px]  rounded-2xl `}
                  style={{ backgroundColor: category.color }}
                >
                  <div className="w-full h-12 relative">
                    <div className=" absolute bottom-0 left-[calc(50%-48px)]">
                      <div className=" w-24 h-24 relative">
                        <ImagePrepare width={96} media={category.icon} alt={category.name} />
                      </div>
                    </div>
                  </div>
                  <div className=" w-full h-12 flex items-center justify-center">
                    <p className=" font-normal text-sm text-[#333]">
                      {category.name}
                    </p>
                  </div>
                </div>
              </div>

            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryList;
